﻿import keycode from 'keycode'

/** Component Class for LanguageSelector */
export class LanguageSelector {
    /**
     * Creates a new instance of a LanguageSelector component
     * @param {HTMLElement} element LanguageSelector DOM element
     */
    constructor(element) {
        
        this.element = element;
        if (this.element) {
            this.element.inert = true // determines whether or not the element is can be 'tabbed' to using keyboard navigation
            this._visible = false;

            // Elements
            this.wrapper = element.querySelector('.language-selector__wrapper');
            this.title = element.querySelector('.language-selector__title');
            this.list = element.querySelector('.language-selector__list');
          
            this.closeButton = element.querySelector('.language-selector__close-button');
            this.openRegionButton = element.querySelectorAll('.language-selector__region__button');
            this.countries = element.querySelectorAll('.language-selector__container__countries');
            
            this.overlay = document.querySelector('.language-selector__overlay');
            this.togglerButton = this.element.parentElement;

            // Events
            this.addEventListeners();
        }        
    }

    get visible() {
        return this._visible
    }

    set visible(state) {
        const caretToggleClass = 'is-toggled'
        const visibilityClass = `is-visible`
        this._visible = state
        this.element.inert = !state
        window.requestAnimationFrame(() => {
            if (state) {
                this.element.classList.add(visibilityClass);
                this.element.setAttribute("aria-hidden", "false");
                this.element.setAttribute("tabindex", "0");
                document.querySelectorAll('.language-selector__list__item a, .language-selector__close-button').forEach(elem => {
                    elem.setAttribute("tabindex", "0")
                })
                
                Array.from(this.element.querySelectorAll('img[data-src]')).forEach((countryIcon) => {
                    countryIcon.setAttribute('src', countryIcon.getAttribute('data-src'))
                    countryIcon.removeAttribute('data-src')
                    countryIcon.classList.add('loaded')
                    this.toggleStateRegion = () => {

                        if (!event.target.classList.contains("is-active")) {
                            Array.from(this.openRegionButton).forEach((element) => element.classList.remove("is-active"));;
                            event.target.classList.add("is-active");
                        }
                    };
                })
            } else {
                this.element.classList.remove(visibilityClass);
                this.element.setAttribute("aria-hidden", "true");
                this.element.setAttribute("tabindex", "-1");
                this.togglerButton.focus();
                document.querySelectorAll('.language-selector__list__item a, .language-selector__close-button').forEach(elem => {
                    elem.setAttribute("tabindex", "-1")
                })
            }
            if (this.overlay) {
                if (state) {
                    if (window.matchMedia("(max-width: 979px)").matches){
                        var containerElement = document.getElementById("language-selector-toggler-button");
                        containerElement.scrollIntoView();
                  }
                    this.overlay.classList.add(visibilityClass);
                } else {
                    this.overlay.classList.remove(visibilityClass);
                }
            }
        })
    }

    /** Adds event listerners for handling keyboard navigation and click events */
    addEventListeners() {
        if(this.closeButton){
            this.closeButton.addEventListener('click', (e) => {
                this.visible = !this.visible
            });
        }

        if(this.togglerButton){
            this.togglerButton.addEventListener('click', (e) => {
                if(e.target !== this.overlay && e.target !== this.closeButton && e.target !== this.wrapper && e.target !== this.element && e.target !== this.title) {
                    this.visible = !this.visible   
                }
            });
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', (e) => {
                this.visible = !this.visible;
            });
        }

        Array.from(this.openRegionButton).forEach((element) => element.addEventListener('click', () => this.toggleStateRegion()));
        document.addEventListener('keydown', (event) => {
            switch (keycode(event)) {
                case 'esc':
                    if (this.visible) this.visible = false
                    break
                case 'enter':
                    if (document.activeElement === this.togglerButton) this.visible = true
                    break
            }
        })
    }
}
